import { render } from "./CashierInventoriesView.vue?vue&type=template&id=667b9096&scoped=true"
import script from "./CashierInventoriesView.vue?vue&type=script&lang=js"
export * from "./CashierInventoriesView.vue?vue&type=script&lang=js"

import "./CashierInventoriesView.vue?vue&type=style&index=0&id=667b9096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667b9096"]])

export default __exports__